import { useEffect } from 'react';
import { useLocation } from 'wouter';

/** Registration is now part of the onboarding flow. */
export default function Registration() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    setLocation('/onboarding');
  }, [setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-hydro-100">
      <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-200 border-t-purple-600" />
    </div>
  );
}
